import { render } from "./AccountView.vue?vue&type=template&id=4cc4bff8&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./AccountView.vue?vue&type=style&index=1&id=4cc4bff8&lang=css"
import "./AccountView.vue?vue&type=style&index=2&id=4cc4bff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc4bff8"]])

export default __exports__